var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"make-bracelet-title"},[_c('div',{staticClass:"make-bracelet-title-top"},[_vm._v(_vm._s(_vm.top))]),_c('div',{staticClass:"make-bracelet-title-bottom"},[_vm._v(_vm._s(_vm.bottom))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }